import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ImmoTaskForEdit } from './immo-task-for-edit';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class GetImmoTaskForEditControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;

  private readonly deserialize = (res) => res as ImmoTaskForEdit;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/immotask/forEdit', requestServices);
  }

  public getForEdit(id: number): Promise<ImmoTaskForEdit> {
    return this.get(`/${id}`, this.deserialize).toPromise();
  }
}
